import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-bootstrap/Modal';
import classes from './FullscreenModal.module.css'


// const NewModal = ({show,onHide,className,children, ...rest}) => {
//   return (
//     <Modal show={show} centered="true" onHide={onHide} {...rest}>
//       <Modal.Body className={`${className} ${classes.modalbody}`}>
//         <i className={`${classes["close-btn"]} bx bx-x`} onClick={onHide}></i>
//         {children}
//       </Modal.Body>
//     </Modal>
//   );
// }

// const Modals = ({show,onHide,className,children, ...rest}) => {
//     return ReactDOM.createPortal(
//       <NewModal show={show} onHide={onHide} {...rest}>{children}</NewModal>,
//       document.getElementById("modal")
//     );
// }
const FullscreenModal = ({show,onHide,className,children, ...rest}) => {
  return ReactDOM.createPortal(
    <Modal show={show} fullscreen={true} centered="true" onHide={onHide} {...rest}>
      <Modal.Body className={`${className?className:''} ${classes.modalbody}`}>
        <i className={`${classes["close-btn"]} bx bx-x`} onClick={onHide}></i>
        {children}
      </Modal.Body>
    </Modal>,
    document.getElementById("modal")
  );
}

export default FullscreenModal;